// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container__1E47T"};